export default "__VITE_ASSET__U5AW30TX__"